import React, { useState, useEffect } from "react";
import { Modal, Button, Form, FormGroup, FormControl } from "react-bootstrap";
import BoatHelm from "../../../../Asset/icon/boat_helm.svg";
import { useTranslation } from "react-i18next";
import { ContactData } from "../../../../components/data/ContactData";
import { useDispatch } from "react-redux";
import { sendEmailAction } from "../../../../redux/Auth/AuthSlice";
import { IconButton, Snackbar, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../../../../Asset/scss/takemyyacht.scss";

function ContactUs() {
  const { t } = useTranslation();
  const companyInfo = ContactData[0];
  const [showModal, setShowModal] = useState(false);
  const [tel, setTel] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem("selectedLanguage") || "en"
  );

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");

  const dispatch = useDispatch();

  const handleTelChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setTel(value);
  };

  useEffect(() => {
    const language = localStorage.getItem("selectedLanguage");
    if (language) {
      setSelectedLanguage(language);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!firstName || !lastName || !email || !tel || !message) {
      setSnackbarMsg(t("All fields are required."));
      setSnackbarSeverity("warning");
      setOpenSnackbar(true);
      return;
    }

    const emailData = {
      recipient: "info@takemyyacht.com",
      firstName,
      lastName,
      tel,
      email,
      message,
    };

    try {
      const result = await dispatch(sendEmailAction(emailData));
      if (result.status === "success") {
        setShowSuccess(true);
        setFirstName("");
        setLastName("");
        setEmail("");
        setTel("");
        setMessage("");

        setSnackbarMsg(t("Your message has been sent successfully."));
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Failed to send email:", error);
      setSnackbarMsg(t("Failed to send email."));
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => setShowSuccess(false);

  return (
    <>
      <div className="ContainerContactUs">
        <div className="mb-4">
          <img
            className="BoatHelm-1"
            draggable={false}
            src={BoatHelm}
            alt="BoatHelm"
          />
          <h2>{t("Contact Us")}</h2>
        </div>

        {/* ✅ ลบ col-sm-6 col-md-12 ออก */}
        <Form className="row justify-content-center" onSubmit={handleSubmit}>
          <FormGroup className="col-12 col-md-6 mb-2">
            <Form.Label className="d-flex align-items-start m-0">
              {t("First Name")} *
            </Form.Label>
            <FormControl
              type="text"
              placeholder={t("First Name")}
              name="firstName"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </FormGroup>

          <FormGroup className="col-12 col-md-6 mb-2">
            <Form.Label className="d-flex align-items-start m-0">
              {t("Last Name")} *
            </Form.Label>
            <FormControl
              type="text"
              placeholder={t("Last Name")}
              name="lastName"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </FormGroup>

          <FormGroup className="col-12 col-md-6 mb-2">
            <Form.Label className="d-flex align-items-start m-0">
              {t("Tel.")} *
            </Form.Label>
            <FormControl
              type="tel"
              placeholder={t("Tel.")}
              value={tel}
              onChange={handleTelChange}
            />
          </FormGroup>

          <FormGroup className="col-12 col-md-6 mb-2">
            <Form.Label className="d-flex align-items-start m-0">
              {t("Email")} *
            </Form.Label>
            <FormControl
              type="email"
              placeholder={t("Email")}
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormGroup>

          <FormGroup className="col-12 mb-2">
            <Form.Label className="d-flex align-items-start m-0">
              {t("Message")}
            </Form.Label>
            <FormControl
              as="textarea"
              rows={3}
              placeholder={t("Message")}
              name="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </FormGroup>

          <FormGroup className="col-12 mb-2 mt-3">
            <Button
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? t("Submitting...") : t("Submit")}
            </Button>
          </FormGroup>
        </Form>

        {showSuccess && (
          <div className="ContainerContact" onClick={handleClose}>
            <div className="CenteredModal" onClick={(e) => e.stopPropagation()}>
              <div className="ContactHeader">
                <h2 className="TextContact">{t("Contact Us")}</h2>
                <IconButton
                  className="CloseButtonContact"
                  onClick={handleClose}
                >
                  <CloseIcon />
                </IconButton>
              </div>

              <p className="TextThankContact">
                {t("Thank you for contacting us.")} <br />
                {t("We will get back to you as soon as possible.")}
              </p>

              <Button
                id="province-dropdown"
                variant="primary"
                onClick={handleClose}
              >
                {t("Done")}
              </Button>
            </div>
          </div>
        )}
      </div>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{ width: "auto" }}
      >
        <Alert
          sx={{ borderRadius: 8 }}
          elevation={6}
          variant="filled"
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>
    </>
  );
}

export default ContactUs;
